export const unitToImgUrl = (unit = "") => {
  let res = "";
  switch (unit) {
    case "UnitA":
      res = "case5.png";
      break;
    case "UnitB":
      res = "case6.png";
      break;
    case "UnitC":
      res = "case7.png";
      break;
    case "UnitD":
      res = "case8.png";
      break;
    case "UnitE":
      res = "case9.png";
      break;
    case "UnitF":
      res = "case10.png";
      break;
    case "UnitG":
      res = "case11.png";
      break;
    case "UnitH":
      res = "case12.png";
      break;
    case "UnitI":
      res = "case13.png";
      break;
    case "UnitJ":
      res = "case14.png";
      break;
    case "UnitK":
      res = "case15.png";
      break;
    case "UnitL":
      res = "case16.png";
      break;
    case "UnitM":
      res = "case17.png";
      break;
    case "UnitN":
      res = "case18.png";
      break;
    case "UnitO":
      res = "case19.png";
      break;
    case "UnitP":
      res = "case20.png";
      break;
    case "UnitQ":
      res = "case21.png";
      break;
    // case "UnitR":
    //   res = "case22.png";
    //   break;
    // case "UnitS":
    //   res = "case23.png";
    //   break;
    // case "UnitT":
    //   res = "case24.png";
    //   break;
    // case "UnitU":
    //   res = "case25.png";
    //   break;
    // case "UnitV":
    //   res = "case26.png";
    //   break;
    // case "UnitW":
    //   res = "case27.png";
    //   break;
    // case "UnitX":
    //   res = "case28.png";
    //   break;
    // case "UnitY":
    //   res = "case29.png";
    //   break;
    // case "UnitZ":
    //   res = "case30.png";
    //   break;
    default:
      res = "";
      break;
  }
  return res;
};

/** 下面两个数组要一一对应 */
export const unitList = [
  "UnitA",
  "UnitB",
  "UnitC",
  "UnitD",
  "UnitE",
  "UnitF",
  "UnitG",
  "UnitH",
  "UnitI",
  "UnitJ",
  "UnitK",
  "UnitL",
  "UnitM",
  "UnitN",
  "UnitO",
  "UnitP",
  "UnitQ",
  "METTING"
];
export const caseList = [
  "case5",
  "survey",
  "case7",
  "case8",
  "case9",
  "case10",
  "case11",
  "case12",
  "case13",
  "case14",
  "case15",
  "case16",
  "case17",
  "case18",
  "case19",
  "case20",
  "case21",
  "metting"
];

export const e = "站空";
